import { FormikProps } from 'formik';
import { useCallback, useState } from 'react';

export const useIsFormDirty = (): [
  boolean,
  (props: FormikProps<any>) => void
] => {
  const [isFormDirty, setIsFormDirty] = useState<boolean>(false);

  const callbackRef = useCallback((props: FormikProps<any>) => {
    if (props) {
      setIsFormDirty(props.dirty);
    }
  }, []);

  return [isFormDirty, callbackRef];
};
